"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuWidth = exports.fontFamily = exports.transition = exports.sizeSidebar = void 0;
exports.sizeSidebar = '25vw';
exports.transition = '.25s all';
exports.fontFamily = `'Fira Mono', 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace`;
exports.menuWidth = 46;
